import React from "react";
import { LongTextMarkSchemeStep } from "./LongTextMarkSchemeStep";
import { MultipleChoiceMarkSchemeStep } from "./MultipleChoiceMarkSchemeStep";
import { AvailableQuestionTypes } from "./QuestionTypePicker";

export function validateMarkScheme(selectedQuestionType, markScheme) {
  switch (selectedQuestionType) {
    case AvailableQuestionTypes.LongText.backendName: {
      return (
        markScheme.modelAnswerGuidance?.trim() !== "" &&
        (markScheme.objectives?.length ?? 0) > 0
      );
    }

    case AvailableQuestionTypes.MultipleChoice.backendName: {
      const opts = markScheme.options || [];
      return opts.length > 1 && opts.some((o) => o.isCorrect);
    }

    case AvailableQuestionTypes.TrueFalse.backendName: {
      const opts = markScheme.options || [];
      const hasTwoOptions = opts.length === 2;
      const correctCount = opts.filter((o) => o.isCorrect).length;
      return hasTwoOptions && correctCount === 1;
    }

    default:
      return false;
  }
}

const MarkSchemeStepWrapper = ({
  question,
  markScheme,
  onChangeMarkScheme,
  selectedQuestionType = null,
  readOnly = false,
  hideTitle = false,
  hideQuestion = false,
}) => {
  if (!readOnly && typeof onChangeMarkScheme !== "function") {
    throw new Error(
      "MarkSchemeStep: `onChangeMarkScheme` must be provided when `readOnly` is false.",
    );
  }
  let questionType;
  if (selectedQuestionType) {
    questionType = selectedQuestionType;
  } else {
    questionType = question.questionType;
  }
  if (questionType === AvailableQuestionTypes.LongText.backendName) {
    return (
      <LongTextMarkSchemeStep
        question={question}
        markScheme={markScheme}
        onChangeMarkScheme={onChangeMarkScheme}
        readOnly={readOnly}
      />
    );
  }
  if (questionType === AvailableQuestionTypes.MultipleChoice.backendName) {
    return (
      <MultipleChoiceMarkSchemeStep
        question={question}
        markScheme={markScheme || { options: question.options }}
        onChangeMarkScheme={onChangeMarkScheme}
        readOnly={readOnly}
        hideTitle={hideTitle}
        hideQuestion={hideQuestion}
      />
    );
  }
  if (questionType === AvailableQuestionTypes.TrueFalse.backendName) {
    return (
      <MultipleChoiceMarkSchemeStep
        question={question}
        markScheme={markScheme || { options: question.options }}
        onChangeMarkScheme={onChangeMarkScheme}
        readOnly={readOnly}
        hideTitle={hideTitle}
        hideQuestion={hideQuestion}
        trueOrFalse
      />
    );
  }
};

export { MarkSchemeStepWrapper };
